import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Alert,
  Link,
} from "@mui/material";

const DeleteAccountPage = () => {
  const steps = [
    "Open the Eatzy app on your device and navigate to the Drawer Panel by tapping the menu icon (three horizontal lines).",
    "In the Drawer Panel, tap on 'Settings' to open your account settings.",
    "Scroll down and select the 'Delete Account' option.",
    "Read the confirmation prompt carefully to understand the consequences.",
    "Tap on 'Delete Account' to confirm your request.",
    "Wait while the app processes your request. Do not close the app during this process.",
    "Once completed, you will receive a confirmation message stating your account has been deleted.",
  ];

  return (
    <Container maxWidth="md">
      <Box mt={5} mb={5}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          {/* Title */}
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Delete Your Eatzy Account
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={3}>
            Follow the steps below to permanently delete your Eatzy account.
          </Typography>

          {/* Steps */}
          <List>
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Typography fontWeight="medium">
                        {index + 1}. {step}
                      </Typography>
                    }
                  />
                </ListItem>
                {index !== steps.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>

          {/* Warning */}
          <Box mt={4}>
            <Alert severity="warning">
              Once your account is deleted, all your data including order
              history and account details will be permanently removed and cannot
              be recovered.
            </Alert>
          </Box>

          {/* Support */}
          <Box mt={4}>
            <Typography variant="h6" gutterBottom>
              Need Help?
            </Typography>
            <Typography variant="body2">
              If you face any issues while deleting your account, please contact
              our support team at{" "}
              <Link href="mailto:support@eatzy.com">
                support@eatzy.com
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default DeleteAccountPage;